import React from 'react'
import { string, shape, object, func, number, bool } from 'prop-types'
import { Form, InputNumber } from 'antd'
import InfoField from '~/components/infoField'
import { currencyFormatter } from './currencyUtils'
import { useFocusCallback } from 'utils/fieldHooks'

const CurrencyField = ({
	pageFieldsData,
	className,
	onChange,
	onFocus,
	inputValue,
	disabled,
	visible,
}) => {
	const { label, variable, type, id, info, list, optional } = pageFieldsData
	const isObj = typeof variable === 'object'
	const varname = isObj ? variable.name : variable
	const name = id !== undefined ? `${varname}_${id}` : varname

	const locale = 'pt-br'
	const currency = 'BRAZIL::BRL'

	const focusCallback = useFocusCallback(onFocus, pageFieldsData)

	return (
		<Form.Item
			key={name}
			name={list !== undefined ? [list, name] : name}
			label={<InfoField label={label} info={info} />}
			type={type}
			className={className}
			hasFeedback
			rules={
				visible && [
					{ required: !optional, message: 'Este campo é obrigatório.' },
				]
			}
			colon={false}
			initialValue={!inputValue ? '' : Number(inputValue)}>
			<InputNumber
				min={0}
				placeholder=""
				formatter={currencyFormatter(currency, locale)}
				onChange={onChange}
				onFocus={focusCallback}
				parser={(value) => parse(value)}
				disabled={disabled}
				style={{ width: '100%', currency: 'BRL', style: 'currency' }}
			/>
		</Form.Item>
	)
}

function parse(value) {
	if (typeof value === 'number') return value
	if (!value) return 0
	return Number(value.replace(/\D/g, '')) / 100
}

CurrencyField.propTypes = {
	pageFieldsData: shape({
		label: string.isRequired,
		variable: object.isRequired,
		type: string.isRequired,
		info: string,
	}).isRequired,
	className: string,
	onChange: func,
	onFocus: func,
	inputValue: number,
	disabled: bool,
	visible: bool,
}

CurrencyField.defaultProps = {
	visible: true,
}

export default CurrencyField
